import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { AuraChatMock, auraChatMocks } from '../mocks/auraChat';
import { SparklesIcon, UserIcon } from '@heroicons/vue/solid';
import moment from 'moment';
import AuraConversationIcon from '@/assets/icons/aura-conversation.svg';
import { RefreshIcon } from '@heroicons/vue/outline';

interface AuraMessage {
    role: 'user' | 'aura';
    content: string;
    time: string;
    loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactAuraPanel',
  setup(__props, { expose: __expose }) {
  __expose();

const auraPanelOpened = ref(false);

const nowTime = () => {
    return moment().format('HH:mm');
};

const messages = ref<AuraMessage[]>([]);

const askAura = (chat: AuraChatMock) => {
    messages.value.push({
        role: 'user',
        content: chat.question,
        time: nowTime(),
    });

    const processingMessageIndex =
        messages.value.push({
            role: 'aura',
            content: 'O Aura está analisando o histórico...',
            time: nowTime(),
            loading: true,
        }) - 1;

    setTimeout(() => {
        messages.value[processingMessageIndex] = {
            role: 'aura',
            content: chat.answer,
            time: nowTime(),
        };
    }, 3000);
};

const __returned__ = { auraPanelOpened, nowTime, messages, askAura, get auraChatMocks() { return auraChatMocks }, get SparklesIcon() { return SparklesIcon }, get UserIcon() { return UserIcon }, get AuraConversationIcon() { return AuraConversationIcon }, get RefreshIcon() { return RefreshIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})